import { NgModule, Injectable } from '@angular/core';
import { Routes, Router, RouterModule, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AuthGuard } from './app.authGuard';
import { AppConfig } from './app.config';
import { LayoutComponent } from './layout/ph-bhp-layout/layout.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { LoginComponent } from './Authorization/login/login.component';
import { ChangePasswordComponent } from './Authorization/change-password/change-password.component';
import { ResetPasswordComponent } from './Authorization/reset-password/reset-password.component';
import { ForgetPasswordComponent } from './Authorization/forget-password/forget-password.component';
import { UserRegistrationComponent } from './Authorization/user-registration/user-registration.component';
import { PhBhpAddinstitutionComponent } from './institution/ph-bhp-addinstitution/ph-bhp-addinstitution.component';
import { PhBhpManageinstitutionComponent } from './institution/ph-bhp-manageinstitution/ph-bhp-manageinstitution.component';
import { PhBhpTrialinstitutionComponent } from './institution/ph-bhp-trialinstitution/ph-bhp-trialinstitution.component';

import { ManageSopComponent } from './SOPManagement/managesop/manageSop.component';
import { SopComponent } from './SOPManagement/sop/sop.component';

import { SopObserveComponent } from './SOPObservation/sop/sop.component';
import { PhBhpNewSopobserveComponent } from './SOPObservation/ph-bhp-new-sopobserve/ph-bhp-new-sopobserve.component';
import { PhBhpObserveProtocolComponent } from './SOPObservation/ph-bhp-observe-protocol/ph-bhp-observe-protocol.component';

import { EvaluationComponent } from './evaluation/evaluation/evaluation.component';
import { PhBhpConsumptionComponent } from './evaluation/ph-bhp-consumption/ph-bhp-consumption.component';
import { PhBhpConsumptionsPatientComponent } from './evaluation/ph-bhp-consumptions-patient/ph-bhp-consumptions-patient.component';
import { ObserveSopComponent } from './evaluation/observeSop/observeSop.component';
import { ReportSopComponent } from './evaluation/reportSop/reportSop.component';
import { SopStatisticalComponent } from './evaluation/sopStatistical/sopStatistical.component';
import { SopProcessComplianceComponent } from './evaluation/sopProcessCompliance/sopProcessCompliance.component';
import { SopSubStepComplianceComponent } from './evaluation/sopSubStepCompliance/sopSubStepCompliance.component';
import { SopFrequencyDistributionComponent } from './evaluation/sopFrequencyDistribution/sopFrequencyDistribution.component';
import { sopCommentsComponent } from './evaluation/sopComments/sopComments.component';
import { SopIndividualOverviewComponent } from './evaluation/sopIndividualOverview/sopIndividualOverview.component';
import { PhBhpObserveStaticalEvaluationComponent } from './evaluation/ph-bhp-observe-statical-evaluation/ph-bhp-observe-statical-evaluation.component';
import { PhBhpObserveOverallComplianceComponent } from './evaluation/ph-bhp-observe-overall-compliance/ph-bhp-observe-overall-compliance.component';
import { PhBhpObserveFivemomentsComponent } from './evaluation/ph-bhp-observe-fivemoments/ph-bhp-observe-fivemoments.component';
import { PhBhpObserveStatisticsBeforeAsepticProceduresComponent } from './evaluation/ph-bhp-observe-statistics-before-aseptic-procedures/ph-bhp-observe-statistics-before-aseptic-procedures.component';
import { PhBhpObserveQuotaComponent } from './evaluation/ph-bhp-observe-quota/ph-bhp-observe-quota.component';
import { PhBhpObserveOverviewindividualdataComponent } from './evaluation/ph-bhp-observe-overviewindividualdata/ph-bhp-observe-overviewindividualdata.component';
import { PhBhpConsumptionStaticalEvaluationComponent } from './evaluation/ph-bhp-consumption-statical-evaluation/ph-bhp-consumption-statical-evaluation.component';

import { ObserveObserveRouterModule } from './ObserveObservation/observe-routing.module';

import { HygieneCheckComponent } from './evaluation/hygiene-check/hygiene-check.component';

import { ConsumptionComponent } from './Consumption/consumption/consumption.component';
import { PhBhpNewConsumptionComponent } from './Consumption/ph-bhp-new-consumption/ph-bhp-new-consumption.component';
import { PhBhpPastConsumptionComponent } from './Consumption/ph-bhp-past-consumption/ph-bhp-past-consumption.component';

import { PhBhpAdduserComponent } from './user/ph-bhp-adduser/ph-bhp-adduser.component';
import { PhBhpManageuserComponent } from './user/ph-bhp-manageuser/ph-bhp-manageuser.component';
import { PhBhpViewuserComponent } from './user/ph-bhp-viewuser/ph-bhp-viewuser.component';

import { ElearningComponent } from './elearning/elearning/elearning.component';
import { ManageelearningComponent } from './elearning/manageelearning/manageelearning.component';
import { ManagepuzzlesComponent } from './elearning//managepuzzles/managepuzzles.component';
import { StartpuzzleComponent } from './elearning/startpuzzle/startpuzzle.component';


import { PhBhpParentViewConsumptionComponent } from './Consumption/ph-bhp-parent-view-consumption/ph-bhp-parent-view-consumption.component';
import { PhBhpConfigureNewQuotaComponent } from './ObserveObservation/ph-bhp-observe-new-quota/ph-bhp-observe-new-quota.component';

import { ConfigureRouterModule } from './configure/configure-routing.module';
import { ChcRouterModule } from './chc/chc-routing.module';


import { Page401Component } from './Pages/page-401/page-401.component';
import { Page404Component } from './Pages/page-404/page-404.component';
import { MyTaskRouterModule } from './myTask/myTask-routing.model';
import { ProfileComponent } from './Authorization/profile/profile.component';
import { ViewInstitutionRouterModule } from './institution/ph-bhp-viewinstitution/view-institution-routing.module';
import { WebKessManageRouterModule } from './institution/ph-bhp-webKess/webkess-manage-routing.module';
import { MigrationToolComponent } from './migration-tool/migration-tool.component';

import { PhBhpObserveCommentsComponent } from './evaluation/ph-bhp-observe-comments/ph-bhp-observe-comments.component';
import { HygieneCheckEditorComponent } from './check/hygiene-check-editor/hygiene-check-editor.component';
import { HygieneCheckListComponent } from './check/hygiene-check-list/hygiene-check-list.component';
import { HygieneCheckMenuComponent } from './check/hygiene-check-menu/hygiene-check-menu.component';
import { NewHygieneCheckComponent } from './check/new-hygiene-check/new-hygiene-check.component';
import { HygieneCheckQuestionnaireEditorComponent } from './check/hygiene-check-questionnaire-editor/hygiene-check-questionnaire-editor.component';
import { HygieneCheckQuestionnairePreviewComponent } from './check/hygiene-check-questionnaire-preview/hygiene-check-questionnaire-preview.component';
import { HygieneCheckQuestionManagerComponent } from './check/hygiene-check-question-manager/hygiene-check-question-manager.component';
import { HygieneCheckCountryEditorComponent } from './check/hygiene-check-country-editor/hygiene-check-country-editor.component';
import { HygieneCheckPageComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-check/public_api';
import { HygieneCheckStatisticalComponent } from './evaluation/hygiene-check-statistical/hygiene-check-statistical.component';
import { HygieneCheckEvaluationComplianceComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-evaluation-compliance/hygiene-check-evaluation-compliance.component';
import { HygieneCheckEvaluationIndividualDataComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-evaluation-individual-data/hygiene-check-evaluation-individual-data.component';
import { HygieneCheckEvaluationOverallComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-evaluation-overall/hygiene-check-evaluation-overall.component';
import { HygieneCheckEvaluationQuickcommentsComponent } from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/lib/hygiene-check-evaluation-quickcomments/hygiene-check-evaluation-quickcomments.component';

@Injectable({ providedIn: 'root' })
export class CoutryActivate implements CanActivate {
  constructor(private router: Router, private config: AppConfig) {

  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {

    if (this.config.userData.roleName.roleId == 1) {
      this.router.navigate(['/configure/country']);

    }
    else if (this.config.userData.roleName.roleId == 2) {
      this.router.navigate(['/configure/department']);

    }
    else if (this.config.userData.roleName.roleId == 3 || this.config.userData.roleName.roleId == 4) {
      this.router.navigate(['/configure/wards']);
    }
    return false;
  }
}

const routes: Routes = [
  {
    path: '', component: LayoutComponent, children: [
      { path: '404', component: Page404Component },
      { path: '401', component: Page401Component },
      { path: '', redirectTo: 'dashboard', pathMatch: 'full', canActivate: [AuthGuard] },
      { path: 'profile', component: ProfileComponent, canActivate: [AuthGuard] },
      { path: 'dashboard', component: DashboardComponent, canActivate: [AuthGuard] },
      { path: 'changePassword', component: ChangePasswordComponent, canActivate: [AuthGuard] },
      { path: 'elearning', component: ElearningComponent, canActivate: [AuthGuard] },
      { path: 'elearning/manage', component: ManageelearningComponent, canActivate: [AuthGuard] },
      { path: 'elearning/puzzles', component: ManagepuzzlesComponent, canActivate: [AuthGuard] },
      { path: 'elearning/puzzles/start/:id', component: StartpuzzleComponent, canActivate: [AuthGuard] },
      { path: 'sop', component: SopComponent, canActivate: [AuthGuard] },
      { path: 'sop/create', component: ManageSopComponent, canActivate: [AuthGuard] },
      { path: 'sop/:viewType/:sopId', component: ManageSopComponent, canActivate: [AuthGuard] },
      { path: 'sop/:viewType/:sopId/:versionNo', component: ManageSopComponent, canActivate: [AuthGuard] },
      { path: 'institution', component: PhBhpManageinstitutionComponent, canActivate: [AuthGuard] },
      { path: 'institution/add', component: PhBhpAddinstitutionComponent, canActivate: [AuthGuard] },
      { path: 'institution/trial', component: PhBhpTrialinstitutionComponent, canActivate: [AuthGuard] },
      { path: 'institution/edit/:id', component: PhBhpAddinstitutionComponent, canActivate: [AuthGuard] },
      { path: 'user/add', component: PhBhpAdduserComponent, canActivate: [AuthGuard] },
      { path: 'user/addInstitution/:institutionId/:isGroup', component: PhBhpAdduserComponent, canActivate: [AuthGuard] },
      { path: 'user/edit/:userid', component: PhBhpAdduserComponent, canActivate: [AuthGuard] },
      { path: 'user', component: PhBhpManageuserComponent, canActivate: [AuthGuard] },
      { path: 'user/view/:userid', component: PhBhpViewuserComponent, canActivate: [AuthGuard] },
      { path: 'migrationtool', component: MigrationToolComponent, canActivate: [AuthGuard] },
      ConfigureRouterModule, ChcRouterModule, ViewInstitutionRouterModule, WebKessManageRouterModule,
      {
        path: 'sopObserve', component: SopObserveComponent, children: [
          { path: 'newObserve', component: PhBhpNewSopobserveComponent, canActivate: [AuthGuard] },
          { path: 'observeProtocol', component: PhBhpObserveProtocolComponent, canActivate: [AuthGuard] },
          { path: 'sopEditor', component: SopComponent, canActivate: [AuthGuard] },
          { path: '', redirectTo: 'newObserve', pathMatch: 'full', canActivate: [AuthGuard] },
          { path: '**', redirectTo: 'newObserve', canActivate: [AuthGuard] }
        ]
      },
      { path: 'evaluation/observeSOP/processCompliance', component: SopProcessComplianceComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/observeSOP/frequencyDistribution', component: SopFrequencyDistributionComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/observeSOP/subStepCompliance', component: SopSubStepComplianceComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/observeSOP/sopComments', component: sopCommentsComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/observeSOP/sopIndividualOverview', component: SopIndividualOverviewComponent, canActivate: [AuthGuard] },

      { path: 'evaluation/observe/overallCompliance', component: PhBhpObserveOverallComplianceComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/observe/fivemoments', component: PhBhpObserveFivemomentsComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/observe/quota', component: PhBhpObserveQuotaComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/observe/StatisticsBeforeAsepticProcedures', component: PhBhpObserveStatisticsBeforeAsepticProceduresComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/observe/individualOverview', component: PhBhpObserveOverviewindividualdataComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/observe/comments', component: PhBhpObserveCommentsComponent, canActivate: [AuthGuard]},

      { path: 'evaluation/consumption/totalConsumption', component: PhBhpConsumptionComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/consumption/consumptionPerPatient', component: PhBhpConsumptionsPatientComponent, canActivate: [AuthGuard] },

      { path: 'evaluation/hygiene-check/quickComments', component: HygieneCheckEvaluationQuickcommentsComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/hygiene-check/complianceQuestions', component: HygieneCheckEvaluationComplianceComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/hygiene-check/overallCompliance', component: HygieneCheckEvaluationOverallComponent, canActivate: [AuthGuard] },
      { path: 'evaluation/hygiene-check/individualData', component: HygieneCheckEvaluationIndividualDataComponent, canActivate: [AuthGuard] },

      ObserveObserveRouterModule, MyTaskRouterModule,

      {
        path: 'evaluation', component: EvaluationComponent, children: [
          { path: 'reportSop', component: ReportSopComponent, canActivate: [AuthGuard] },
          {
            path: 'observeSOP', component: ObserveSopComponent, children: [
              { path: 'reportSop', component: ReportSopComponent, canActivate: [AuthGuard] },
              { path: 'statistical', component: SopStatisticalComponent, canActivate: [AuthGuard] },
              { path: '', redirectTo: 'statistical', pathMatch: 'full', canActivate: [AuthGuard] },
              { path: '**', redirectTo: 'statistical', canActivate: [AuthGuard] }
            ]
          },
          {
            path: 'observeObservation/statistical', component: PhBhpObserveStaticalEvaluationComponent, canActivate: [AuthGuard]
          },
          { path: 'consumption/statistical', component: PhBhpConsumptionStaticalEvaluationComponent, canActivate: [AuthGuard] },
          {
            path: 'hygiene-check', component: HygieneCheckComponent, children: [
              { path: 'statistical', component: HygieneCheckStatisticalComponent, canActivate: [AuthGuard] },
              { path: '', redirectTo: 'statistical', pathMatch: 'full', canActivate: [AuthGuard] },
              { path: '**', redirectTo: 'statistical', canActivate: [AuthGuard] }
            ]
          },
          { path: '', redirectTo: 'reportSop', pathMatch: 'full', canActivate: [AuthGuard] },
          { path: '**', redirectTo: 'reportSop', canActivate: [AuthGuard] },
          
        ]
      },
      {
        path: 'consumption', component: ConsumptionComponent, children: [
          { path: '', redirectTo: 'new', pathMatch: 'full', canActivate: [AuthGuard] },
          { path: 'new', component: PhBhpNewConsumptionComponent, canActivate: [AuthGuard] },
          { path: 'new/start/:period/:Id', component: PhBhpParentViewConsumptionComponent, canActivate: [AuthGuard] },
          { path: 'past', component: PhBhpPastConsumptionComponent, canActivate: [AuthGuard] },
          { path: '**', redirectTo: 'new', canActivate: [AuthGuard] }
        ]
      },
      //  ++++ Check module ++++
      {
        path: 'hygiene-check-menu', component: HygieneCheckMenuComponent, children: [
          { path: 'hygiene-check', component: HygieneCheckListComponent, canActivate: [AuthGuard] },
          { path: 'new-hygiene-check', component: NewHygieneCheckComponent, canActivate: [AuthGuard] },
          { path: 'hygiene-check-editor', component: HygieneCheckEditorComponent, canActivate: [AuthGuard] },
          { path: 'edit/:id', component: HygieneCheckPageComponent, canActivate: [AuthGuard] },
          { path: 'view/:id', component: HygieneCheckPageComponent, canActivate: [AuthGuard] }
        ]
      },
      { path: 'hygiene-check-editor', component: HygieneCheckCountryEditorComponent, canActivate: [AuthGuard] },
      { path: 'questionnaire-editor/:id', component: HygieneCheckQuestionnaireEditorComponent, canActivate: [AuthGuard] },
      { path: 'questionnaire-viewer/:id', component: HygieneCheckQuestionnairePreviewComponent, canActivate: [AuthGuard] },
      
      // ---- Check module ----
    ]
  },
  
  
  { path: 'login', component: LoginComponent },
  { path: 'forgetpassword', component: ForgetPasswordComponent },
  { path: 'signin', component: UserRegistrationComponent },
  { path: 'resetPassword/:validationKey/:languageCode', component: ResetPasswordComponent },
  { path: '**', redirectTo: '404' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
